import { ChangeLocalUserInfoMessage } from "@messages/session/SessionMessages";
import { AvatarStyle } from "flavr-common";
import { usersService } from "../multiplayer/UsersService";
import { renderManager } from "../xr/RenderManager";
import { NewModule, PresentationMode } from "../module/NewModule";
/**
 * Keeps the local avatar style aligned with the current presentation mode so desktop and XR users are represented appropriately: it switches to a head avatar when the player enters an XR/VR presentation session, and back to a monitor avatar otherwise.
 */
export class AutoChoosePlayerForDeviceModule extends NewModule {
    constructor() {
        super("AutoChoosePlayerForDeviceModule");
    }
    /// Life cycle methods ///
    onInit() {
        if (renderManager.isXRPresenting()) {
            this.changeAvatarStyle(AvatarStyle.Head);
        }
    }
    onPresentationModeChanged(presentationMode) {
        this.changeAvatarStyle(presentationMode === PresentationMode.VR ? AvatarStyle.Head : AvatarStyle.Monitor);
    }
    /// Private helper methods ///
    changeAvatarStyle(style) {
        const user = usersService.getLocalUser();
        user.avatar.style = style;
        this.connection.send(new ChangeLocalUserInfoMessage({
            customUsername: usersService.getLocalDisplayName(),
            avatar: user.avatar
        }));
    }
}
